import { EventEmitter, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/core/services/api.service';

@Injectable({
  providedIn: 'root'
})
export class ReferringDoctorService extends ApiService {
  public eventEmitter = new EventEmitter();
  public getReferringDoctor(param): Observable<any> {
    return this.request({
      path: 'referring-doctors/',
      method: 'GET',
      query: param
    });
  }

  public deleteReferringDoctor(id): Observable<any> {
    return this.request({
      path: `referring-doctors/${id}`,
      method: 'DELETE'
    });
  }

  public updateReferringDoctor(data, id): Observable<any> {
    return this.request({
      path: `referring-doctors/${id}`,
      method: 'PUT',
      body: data
    });
  }

  public create(data): Observable<any> {
    return this.request({
      path: 'referring-doctors',
      method: 'POST',
      body: data
    });
  }

  public getReferringDoctorById(id): Observable<any> {
    return this.request({
      path: `referring-doctors/${id}`,
      method: 'GET'
    });
  }

}
